import {defineAction} from 'redux-define';
import {createAction} from 'redux-actions';
import {put, take, race, call, takeLatest} from 'redux-saga/effects';

import {createInviteSaga} from 'api/invite';
import {getDealInvites} from 'api/deals';

import {showInvite, hideInvite} from './reducer';

const namespace = 'flows/deal/announce';

// Actions
const SEND_INVITE = defineAction('SEND_INVITE', ['SUBMIT', 'CANCEL'], namespace);
export const sendInvite = createAction(SEND_INVITE.ACTION);
export const submitInvite = createAction(SEND_INVITE.SUBMIT);
export const cancelInvite = createAction(SEND_INVITE.CANCEL);

// Deal Lead Saga
export function* sendInviteSaga({payload}) {
  // show announcement popup
  yield put(showInvite());

  // Wait
  const {submit} = yield race({
    submit: take(SEND_INVITE.SUBMIT),
    cancel: take(SEND_INVITE.CANCEL),
  });

  if (submit) {
    // Do the API call
    const message = submit.payload.message.replace(new RegExp('\r?\n','g'), '<br />');
    yield call(createInviteSaga, {
      payload: {
        deal: payload.deal,
        message,
        email: submit.payload.email,
      },
    });

    // Reload invite list
    yield put(getDealInvites({id: payload.deal.id}))
  }

  // hide announcement modal
  yield put(hideInvite());
}

export function* sagas() {
  yield takeLatest(SEND_INVITE.ACTION, sendInviteSaga);
}



// WEBPACK FOOTER //
// ./mobile/shared/flows/deal/invite/index.js